import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialState: EventMetrics = {
    result: {
        CountAttendees: 0,
        CountInvites: 0,
        CountAcceptedInvites: 0,
        CountNonInviteAttendees: 0,
        CountUniqueInvites: 0,
        CountRepeatInvites: 0,
        GetTopThreeInvitees: [{}],
        CountShares: { 
            data: {}
        },
        CountCollaboratorInvites: 0,
        CountCollaboratorInviteAccepted: 0,
        GetCollaboratorInfo: {
            nonprofit: 0,
            brand: 0,
            volunteer: 0,
            influencer: 0
        },
        GetEngagement: {
            data:{}
        },
        CountOrgsDonated: 0,
        CountNonProfitDonated: 0,
        CountIndividualDonated: 0
    }
}

export const eventMetricsSlice = createSlice({
    name: 'eventMetrics',
    initialState,
    reducers:{
        updateEventMetrics: (state, action: PayloadAction<EventMetrics>) => action.payload
    }
})

export const {updateEventMetrics} = eventMetricsSlice.actions;
export default eventMetricsSlice.reducer 
